// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".no-contacts[data-v-2189f9e6]{padding-bottom:110px}.gotit-btn[data-v-2189f9e6]{width:140px!important}.empty-img[data-v-2189f9e6]{width:250px}", ""]);
// Exports
module.exports = exports;
